<div class="modal-wrapper">
  <div class="modal-flex-container">
    <div class="modal modal-position" role="dialog" id="modal-dialog" aria-labelledby="dialog-label" aria-modal="true">

      <!-- <form [formGroup]="userForm" autocomplete="off" role="form" class="fieldHeight"> -->
      <!-- Top Close Button Starts -->
      <div class="col-md-12 clear-all top-nav-container">
        <div class="close-top-nav ">
          <strong tabindex="0" id="top-nav-cta-right" name="top-nav-cta-right" class="nav-btn pointer reflect" (click)="close()" (keyup.enter)="close()">{{contentData.btnClose}}</strong>
        </div>
      </div>


      <!-- Top Close Button Ends -->

      <!-- Title and Introduction Secion Starts -->

      <!-- <div class="col-md-12 clear-all title-wrapper">
        <h1 id="applicationSummary-header" class="title-text custom-header-h2">{{contentData.title}}</h1>
      </div> -->
      <div class="row">
        <div class="col-md-12 title-inner-container">
            <h1 id="applicationSummary-header" class="custom-header-h2 responsive-text-8">{{contentData.title}}</h1>
        </div>
      </div>
      <div class="col-md-12 clear-all content-wrapper">
        <p id="applicationSummary-introduction" class="content-top margin-top-0" [innerHTML]="contentData.introduction1"></p>
        <p id="applicationSummary-introduction" class="content-top margin-top-0" *ngIf="!submittedFlag" [innerHTML]="contentData.introduction2"></p>
      </div>
        <!-- Title and Introduction Secion Ends -->
        
        <!-- <div class="col-md-12 underline margin-top margin-bottom-20" *ngIf="responseApplicationData?.applicationSubmissionDate"  >
          <p class="application-date"> {{contentData.applicationDate}}: <span
              class="applicationSubmitDate">{{responseApplicationData?.applicationSubmissionDate}}</span></p>
 
              <p class="application-date">Application Submission Date: <span class="applicationSubmitDate">16/01/2025 11:56</span></p>
        </div> -->
        <div class="app-sub-date-container" *ngIf="responseApplicationData?.applicationSubmissionDate">
          <div class="application-submission-date">
            <p class="application-date flex-basis-50">{{contentData.applicationDate}}:</p>
            <span class="applicationSubmitDate flex-basis-50">{{responseApplicationData?.applicationSubmissionDate}}</span>        
          </div>
        </div>
        <ng-container *ngFor="let list of summaryList">
          <ng-container *ngIf="getVisibility(list)">
            <app-edit-details [productCode]="selectedProductCode" [isEdit]="list.edit" [parent]="'applicationSummary'"
              [title]="list.title" [storeName]="list.storeName" [onClickGoTo]="list.onEditNavigation" (click)="click()"
              [summmaryDataList]="list.control" [isGMP]="resultQuote.isGMP"
              [isGAR]="isGARProduct(resultQuote.garIndicator)" [viewApplication]="submittedFlag"></app-edit-details>
          </ng-container>
        </ng-container>
        
        <div class="col-md-12 underline margin-top margin-bottom"></div>
        <!-- <div class="col-md-12 clear-all">
                        <div class="float-left summaryBtn-padding">
                            <button id="btnViewSummary" (click)="close()" style="margin-right: 0px !important;" class="btn btn-primary" type="button">{{contentData.btnCloseSummary}}</button>
                        </div>
                    </div> -->
        <app-content-bottom-nav (onNextHandler)="close()" [userInputDetail]="afterApplyDetail['buttonConfigSummary']"
          [buttonType]="'button'"></app-content-bottom-nav>
        <!-- </form> -->

    </div>
  </div>
</div>